export default __webpack_public_path__ + "slices/main/assets/public/media/company-card-2@2x.05518ed52af279a2eb15c6d12fe9d427.png";